module.exports = __webpack_public_path__ + "static/media/aakarsh-yadav.1b4ad98d.jpeg";